<template>
    <v-container fluid class="mx-0 px-3">
        <v-card flat class="avsb-card-background">
            <v-card-title class="pl-1 py-2">Customers</v-card-title>
        </v-card>

        <!-- Tables -->
        <TableCustomers />

        <!-- Dialogs -->
        <DialogCustomerCreate />
    </v-container>
</template>

<script>
export default {
    components: {
        DialogCustomerCreate: () =>
            import("@/components/admin/dialogs/dialogCustomerCreate"),
        TableCustomers: () =>
            import("@/components/admin/tables/tableCustomers"),
    },
    methods: {},
    name: "Customers",
    // Lifecycle hooks.
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
};
</script>
